/**
 * Copyright 2025 The Ground Authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const LOI_SEGMENT = 'site';
export const LOI_ID = 'siteId';
export const JOB_ID_NEW = 'new';
export const SUBMISSION_SEGMENT = 'submission';
export const SUBMISSION_ID = 'submissionId';
export const SUBMISSION_ID_NEW = 'new';
export const SURVEY_ID_NEW = 'new';
export const SURVEY_ID = 'surveyId';
export const SURVEY_SEGMENT = 'survey';
export const SIGN_IN_SEGMENT = 'signin';
export const SURVEYS_SEGMENT = 'surveys';
export const SURVEYS_CREATE = 'create';
export const SURVEYS_EDIT = 'edit';
export const SURVEYS_SHARE = 'share';
export const TASK_SEGMENT = 'task';
export const TASK_ID = 'taskId';
export const JOB_SEGMENT = 'job';
export const ERROR = 'error';
export const ABOUT = 'about';
export const TERMS = 'terms';
export const ANDROID_SEGMENT = 'android';
